// extracted by mini-css-extract-plugin
export default {"CreateJob":"create-job_CreateJob__AGwva"};